'use client';

import { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';

function QuickActionsPanel({ onActionClick }) {
  const [activeAction, setActiveAction] = useState(null);

  const quickActions = [
    { id: 'read', icon: 'BookOpenIcon', label: 'Continue Reading', color: 'primary' },
    { id: 'pray', icon: 'HeartIcon', label: 'Prayer Journal', color: 'accent' },
    { id: 'listen', icon: 'SpeakerWaveIcon', label: 'Audiobooks', color: 'secondary' },
    { id: 'notes', icon: 'PencilIcon', label: 'My Notes', color: 'primary' },
    { id: 'search', icon: 'MagnifyingGlassIcon', label: 'Search Scripture', color: 'accent' },
    { id: 'community', icon: 'UserGroupIcon', label: 'Community', color: 'secondary' }
  ];

  const handleActionClick = (actionId) => {
    setActiveAction(actionId);
    onActionClick(actionId);
    setTimeout(() => setActiveAction(null), 200);
  };

  return (
    <div className="bg-card rounded-xl p-6 border border-border">
      <h3 className="text-lg font-crimson font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => handleActionClick(action?.id)}
            className={`flex flex-col items-center justify-center p-4 rounded-lg border-2 contemplative-transition ${
              activeAction === action?.id
                ? 'border-primary bg-primary/10 scale-95' :'border-border hover:border-primary/30 hover:bg-surface'
            }`}
          >
            <Icon 
              name={action?.icon} 
              size={24} 
              className={`mb-2 ${
                action?.color === 'primary' ? 'text-primary' :
                action?.color === 'accent'? 'text-accent' : 'text-secondary'
              }`} 
            />
            <span className="text-sm font-inter font-medium text-foreground text-center">
              {action?.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

QuickActionsPanel.propTypes = {
  onActionClick: PropTypes?.func?.isRequired
};

export default QuickActionsPanel;